import { Card, CardContent } from "@simurgh/feathers/ui/card";
import { Skeleton } from "@simurgh/feathers/ui/skeleton";

export function CardListSkeleton() {
	return (
		<div className="space-y-3">
			{Array.from({ length: 4 }).map((_, index) => (
				<Card key={index} className="hover:shadow-md transition-shadow">
					<CardContent className="p-4">
						<div className="flex items-start justify-between gap-4">
							{/* Left side - Card content */}
							<div className="flex-1 space-y-3">
								{/* Word/Title */}
								<div className="space-y-2">
									<Skeleton className="h-6 w-32" />
									<Skeleton className="h-4 w-48" />
								</div>

								{/* Definition/Translation */}
								<div className="space-y-2">
									<Skeleton className="h-4 w-full" />
									<Skeleton className="h-4 w-5/6" />
								</div>

								{/* Example */}
								<div className="space-y-1">
									<Skeleton className="h-3 w-3/4 opacity-70" />
									<Skeleton className="h-3 w-2/3 opacity-70" />
								</div>
							</div>

							{/* Right side - Metadata and actions */}
							<div className="flex flex-col items-end gap-3">
								{/* Status chips */}
								<div className="flex gap-2">
									<Skeleton className="h-6 w-16 rounded-full" />
									<Skeleton className="h-6 w-20 rounded-full" />
								</div>

								{/* Stats */}
								<div className="space-y-1 text-right">
									<Skeleton className="h-4 w-24" />
									<Skeleton className="h-4 w-20" />
								</div>

								{/* Action buttons */}
								<div className="flex gap-2">
									<Skeleton className="h-8 w-8 rounded" />
									<Skeleton className="h-8 w-8 rounded" />
								</div>
							</div>
						</div>
					</CardContent>
				</Card>
			))}
		</div>
	);
}
